export default __webpack_public_path__ + "static/media/regulatory--end-of-buses-only--g2.5f50ea96.png";